<div class="container">
  <div class="banner banner--top" routerLink="/banners/rotation-anuario">Rotativo</div>
  <div class="banner banner--half" routerLink="/banners/half1-anuario">Half 1</div>
  <div class="banner banner--half" routerLink="/banners/half2-anuario">Half 2</div>
  <div class="banner banner--half" routerLink="/banners/half3-anuario">Half 3</div>
</div>
